import React from 'react'
import { compose } from 'redux'

import { withModalService, withModalServiceProps } from 'services/utils/modal'

import { Button, FooterActions, ModalBox, Typography } from 'components'
import { BasicModalProps } from 'modals'

import i18n from 'translations'

export interface SubmitRegistrationFormModalProps {
  onSubmit: () => void
}

type SubmitRegistrationFormModalFullProps = BasicModalProps & withModalServiceProps & SubmitRegistrationFormModalProps

const SubmitRegistrationFormModal: React.FC<SubmitRegistrationFormModalFullProps> = ({
  hideModal,
  onSubmit,
}) => {
  const handleCancelClick = () => {
    hideModal()
  }

  const handleSubmit = () => {
    onSubmit()
    hideModal()
  }

  return (
    <ModalBox
      maxWidth={600}
      title={i18n.t('modals:SubmitRegistrationForm:title')}
      autoHeight
      onCloseClick={handleCancelClick}
    >
      <Typography>
        {i18n.t('modals:SubmitRegistrationForm:content')}
      </Typography>
      <FooterActions spaceBetween>
        <FooterActions.Group>
          <FooterActions.Item>
            <Button hierarchy="tertiary" label={i18n.t('global:cancel')} negativeMargins onClick={handleCancelClick} />
          </FooterActions.Item>
        </FooterActions.Group>
        <FooterActions.Group>
          <FooterActions.Item>
            <Button label={i18n.t('global:Submit')} negativeMargins onClick={handleSubmit} />
          </FooterActions.Item>
        </FooterActions.Group>
      </FooterActions>
    </ModalBox>
  )
}

const enhance = compose(
  withModalService,
)

export default enhance(SubmitRegistrationFormModal)
